<template>
  <div class="min-h-full h-full">
    <AppLayout class="h-full" v-if="!isLoading">
      <template #content>
        <div v-if="presentations.length > 0">
          <MainTableV2
            ref="listView"
            :presentations="presentations"
            :isProcessing="isRestoring"
            :sortColumn="sortColumn"
            :sortOrder="sortOrder"
            @click-restore="onClickRestore"
            @click-column-header="onSorting"
          ></MainTableV2>
          <div v-if="isLoadingMore" class="text-center">
            <aha-spinner />
          </div>
        </div>
        <EmptyPageLayout v-if="presentations.length === 0">
          <template #content>
            <div class="flex flex-col gap-4 text-center">
              <div class="text-base font-bold">
                {{ $i18nPresenter.t('Nothing in Trash') }}
              </div>
              <aha-button-link
                @click="onClickRedirectLink"
              >
                <span>{{ $i18nPresenter.t('Back to My Presentations') }}</span>
              </aha-button-link>
            </div>
          </template>
        </EmptyPageLayout>
      </template>
    </AppLayout>
    <div v-if="isLoading" class="flex place-content-center min-h-full">
      <aha-logo-loader></aha-logo-loader>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import AppLayout from '@/layouts/AppLayout.vue'
import EmptyPageLayout from '@/layouts/EmptyPageLayout'
import MainTableV2 from '@/components-v2/my-presentations/main-table/MainTableV2.vue'

const BOTTOM_OFFSET = 100

// TODO: Separate this to Controller file
export default {
  components: {
    AppLayout,
    EmptyPageLayout,
    MainTableV2,
  },
  props: {
    presentations: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
    isRestoring: {
      type: Boolean,
      default: false,
    },
    isLoadingMore: {
      type: Boolean,
      default: false,
    },
    onClickRedirectLink: {
      type: Function,
      default: () => ({}),
    },
    onClickRestore: {
      type: Function,
      default: () => ({}),
    },
    onSorting: {
      type: Function,
      default: () => ({}),
    },
    sortColumn: {
      type: String,
      default: '',
    },
    sortOrder: {
      type: String,
      default: '',
    },
    onScrollBottom: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      observer: null,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScrollToEnd)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScrollToEnd)
  },
  methods: {
    handleScrollToEnd: debounce(function handleScrollToEnd() {
      if (!this.$refs.listView) return
      const bottomScreen = window.innerHeight + window.scrollY
      const bottomListView = this.$refs.listView.$el.offsetHeight - BOTTOM_OFFSET
      if (bottomScreen >= bottomListView) {
        this.onScrollBottom()
      }
    }, 100),
  },
}

</script>

<style lang="scss" scoped>

</style>
